<template>
  <el-card
    :body-style="bodyStyle"
    shadow="never"
    :class="[
      isCarousel
        ? isMobileLayout && carouselType === 2
          ? 'carousel__video--width__mobile'
          : 'carousel__width'
        : '',
      'mb-40',
    ]"
  >
    <el-row
      v-if="isMobileLayout && carouselType === 2"
      class="carousel__video--wrapper"
      style="width: 400px"
    >
      <!-- <a :href="blog.videoLink" v-if="blog.type.code == 'VIDEO'" data-fancybox="blog-gallery">
        <el-col class="carousel__video--height carousel__video--width">
          <el-image
            class="carousel__video--height carousel__video--width"
            :src="thumbnail"
            :fit="isCarousel ? 'cover' : 'contain'"
          />
          <el-image
            :src="images.videoTriangleSmall.src"
            fit="cover"
            :z-index="1"
            v-if="blog.type.code == 'VIDEO'"
            style="
              position: relative;
              bottom: 72%;
              left: 27%;
              transform: rotate(90deg);"
          />
          <el-image
            :src="images.videoTriangleSmall.src"
            :fit="isCarousel ? 'cover' : 'contain'"
            :z-index="1"
            v-if="blog.type.code == 'VIDEO'"
            style="
              position: relative;
              bottom: 72%;
              left: 27%;
              transform: rotate(90deg);
            "
          />
        </el-col>
        <el-col
          class="carousel__video--height carousel__video--width ml-10 bg-transparent carousel__video--detail"
        >
          <div v-if="theme" class="highlight text-uppercase carousel__video--theme">
            {{ theme }}
          </div>
          <div class="subtitle1 blog__title mt-5 carousel__video--title">
            {{ title }}
          </div>
        </el-col>
      </a> -->
      <router-link :to="blogView">
        <el-col class="carousel__video--height carousel__video--width" style="position: relative;"  >
          <el-image
            class="carousel__video--height carousel__video--width"
            :src="thumbnail"
            :fit="isCarousel ? 'cover' : 'contain'"
            style="position: relative;"
          />
          <el-image
            :src="images.videoCircleSmall.src"
            fit="cover"
            :z-index="1"
            v-if="blog.type.code == 'VIDEO'"
            class="blog-video-display"
          />
          <el-image
            :src="images.videoTriangleSmall.src"
            :fit="isCarousel ? 'cover' : 'contain'"
            :z-index="1"
            v-if="blog.type.code == 'VIDEO'"
            class="blog-video-display"
          />
        </el-col>
        <el-col
          class="carousel__video--height carousel__video--width bg-transparent carousel__video--detail"
        >
          <div v-if="theme" class="highlight text-uppercase carousel__video--theme">
            {{ theme }}
          </div>
          <div class="subtitle1 blog__title mt-5 carousel__video--title">
            {{ title }}
          </div>
        </el-col>
      </router-link>
    </el-row>
    <div v-else>
      <!-- <a v-if="blog.type.code == 'VIDEO'" :href="blog.videoLink" data-fancybox="blog-gallery">
        <el-row
          name="card-row"
          :class="[
            isCarousel
              ? carouselType === 2
                ? 'carousel__video--height'
                : carouselType === 1
                ? 'carousel__texte--height '
                : 'carousel__image-size'
              : 'thumbnail__dimension',
            'image-container',
          ]"
        >
          <el-col
            :class="[
              isCarousel
                ? carouselType === 2
                  ? 'carousel__video--height carousel__video--width'
                  : carouselType === 1
                  ? 'carousel__texte--height carousel__texte--width'
                  : 'carousel__image-size'
                : 'thumbnail__dimension',
              'image-container position-relative',
            ]"
          >
            <div
              :class="[
                isCarousel
                  ? carouselType === 2
                    ? 'carousel__video--height carousel__video--width'
                    : carouselType === 1
                    ? 'carousel__texte--height carousel__texte--width'
                    : 'blog-background__carousel'
                  : 'blog-background thumbnail-image',
              ]"
              v-bind:style="{ backgroundImage: 'url(' + thumbnail + ')' }"
            ></div>
            <img :src="thumbnail" class="d-none"/>
            <div class="position-absolute play-btn">
              <img :src="playBtn" />
            </div>
          </el-col>
        </el-row>
        <el-row class="mt-5">
          <el-col class="blog__detail">
            <div class="highlight text-uppercase">
              {{ theme }}
            </div>
            <div class="subtitle2 blog__title mt-5" v-html="author"></div>
            <div class="subtitle1 blog__title mt-5">
              {{ title }}
            </div>
          </el-col>
        </el-row>
      </a> -->
      <router-link :to="blogView">
        <el-row
          name="card-row"
          :class="[
            isCarousel
              ? carouselType === 2
                ? 'carousel__video--height'
                : carouselType === 1
                ? 'carousel__texte--height '
                : 'carousel__image-size'
              : 'thumbnail__dimension',
            'image-container',
          ]"
        >
          <el-col
            :class="[
              isCarousel
                ? carouselType === 2
                  ? 'carousel__video--height carousel__video--width'
                  : carouselType === 1
                  ? 'carousel__texte--height carousel__texte--width'
                  : 'carousel__image-size'
                : 'thumbnail__dimension',
              'image-container',
            ]"
          >
            <div
              :class="[
                isCarousel
                  ? carouselType === 2
                    ? 'carousel__video--height carousel__video--width'
                    : carouselType === 1
                    ? 'carousel__texte--height carousel__texte--width'
                    : 'blog-background__carousel'
                  : 'blog-background thumbnail-image',
              ]"
              v-bind:style="{ backgroundImage: 'url(' + thumbnail + ')' }"
            ></div>
          </el-col>
        </el-row>
        <el-row class="mt-5">
          <el-col class="blog__detail">
            <div class="highlight text-uppercase">
              {{ theme }}
            </div>
            <!-- <div class="subtitle2 blog__title mt-5" v-html="relatedProviders"></div> -->
            <div class="subtitle2 blog__title mt-5" >{{ producerName }}</div>
            <div class="bog-subtitle mt-5">
              {{ title }}
            </div>
          </el-col>
        </el-row>
      </router-link>
    </div>
  </el-card>
</template>

<script>
import { find, get } from "@/utils/lodash";
import layoutUtils from "@/utils/layout-utils";

import imgBlogDefault from "@/assets/images/provider/provider-default.png";

import imgCircleSmall from "@/assets/images/blog/video/blog-video-circle-small.svg";

import imgTriangleSmall from "@/assets/images/blog/video/blog-video-triangle-small.svg";
import playBtn from "@/assets/images/blog/video/blog-video-triangle-small.svg";
export default {
  props: {
    blog: {
      type: Object,
      default: () => {},
    },
    isFilterVisible: {
      type: Boolean,
      default: true,
    },
    isCarousel: {
      type: Boolean,
      default: false,
    },
    carouselType: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      playBtn,
    };
  },
  computed: {
    images() {
      return {
        blogDefault: {
          src: imgBlogDefault,
        },
        videoCircleSmall: {
          src: imgCircleSmall,
        },
        videoTriangleSmall: {
          src: imgTriangleSmall,
        },
      };
    },
    blogView() {
      return {
        name: "blog",
        params: {
          slug: get(this.blog, "slug") || get(this.blog, "id", ""),
        },
      };
    },
    producerName() {
      // return `${get(this.blog, "user.firstName")} ${get(
      //   this.blog,
      //   "user.lastName"
      // )}`;
      var author = '';
      if(get(this.blog.relatedProviders[0], "name") != undefined){
         author = `${get(this.blog.relatedProviders[0], "name")} `;
      }
      return author != null ? author : "";
    },
    thumbnail() {
      const thumbnail = get(this.blog, "mainImage.link");

      if (thumbnail == null) {
        return this.images.blogDefault.src;
      }

      return thumbnail;
    },
    theme() {
      const attr = find(
        get(this.blog, "attributes"),
        (x) => get(x, "type.code") === "BLOG_THEME"
      );
      const val = get(attr, "value");

      if (val != null) {
        return val;
      }

      return "";
    },
    title() {
      return get(this.blog, "title");
    },
    author() {
      const author = `<span class="author">By</span> ${get(this.blog, "user.firstName")} ${get(
        this.blog,
        "user.lastName"
      )}`;

      return author != null ? author : "";
    },
    relatedProviders() {
      var author = '';
      if(get(this.blog.relatedProviders[0], "name") != undefined){
         author = `${get(this.blog.relatedProviders[0], "name")} `;
      }
      return author != null ? author : "";
    },
    bodyStyle() {
      if (!layoutUtils.isMobileLayout(this.$mq) && !this.isFilterVisible) {
        return {
          padding: "0 0 0 20px",
        };
      }
      return {
        padding: "0px",
      };
    },
    isMobileLayout() {
      return layoutUtils.isMobileLayout(this.$mq);
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/variables.scss";
$carousel-image-size: 356px;
$carousel-image-size-mobile: 312px;

.el-card {
  border-radius: 0px;
  border: 0;
  background-color: $color-background-area1;
  color: #333333;
  line-height: normal;
  margin: auto;
}
.blog-background {
  border: 0 solid $color-on-background;
  // background-size: contain !important;
}
.blog-background__carousel {
  border: 0 solid $color-background;
  background-color: $color-background;
}

.blog__detail {
  height: 86px;

  & div {
    background-color: rgba(255, 255, 255, 0);
    color: #272421;
    box-sizing: border-box;
    text-align: left;
    line-height: normal;
  }
  .blog__title {
    font-family: $font-family-futura-std;
    font-size: 10px;
    letter-spacing: 1.5px;
    text-transform: uppercase;
  }
}
.blog__title {
  color: $color-on-background !important;
  letter-spacing: 0.25px;
}
// .image-container {
//   position: relative;
// }
.carousel__image-size {
  // sm -
  @media screen and (max-width: $media-md) {
    width: 188px;
    height: 110px !important;
  }
  // md
  @media screen and (min-width: $media-md) and (max-width: $media-lg) {
    width: 296px;
    height: 181px;
  }
  // lg +
  @media screen and (min-width: $media-lg) {
    width: 356px;
    height: 212px;
  }
}
.carousel__width {
  // sm -
  @media screen and (max-width: $media-md) {
    width: $carousel-image-size-mobile;
  }
  // md
  @media screen and (min-width: $media-md) and (max-width: $media-lg) {
    width: $carousel-image-size-mobile;
  }
  // lg +
  @media screen and (min-width: $media-lg) {
    width: $carousel-image-size;
  }
}
.carousel__video--width {
  // sm -
  @media screen and (max-width: $media-md) {
    width: 188px;
  }
  // md
  @media screen and (min-width: $media-md) and (max-width: $media-lg) {
    width: 298px;
  }
  // lg +
  @media screen and (min-width: $media-lg) {
    width: 350px;
  }
}
.carousel__video--height {
  // sm -
  @media screen and (max-width: $media-md) {
    height: auto !important;
  }
  // md
  @media screen and (min-width: $media-md) and (max-width: $media-lg) {
    height: 370px;
  }
  // lg +
  @media screen and (min-width: $media-lg) {
    height: 350px;
  }
}
.carousel__texte--width {
  // sm -
  @media screen and (max-width: $media-lg) {
    width: 300px;
  }
  // lg +
  @media screen and (min-width: $media-lg) {
    width: 350px;
  }
}

.carousel__texte--height {
  // sm -
  @media screen and (max-width: $media-lg) {
    height: 300px;
  }
  // lg +
  @media screen and (min-width: $media-lg) {
    height: 350px;
  }
}

.carousel__video--width__mobile {
  max-width: 382px;
}

.carousel__video--title {
  letter-spacing: 0.15px !important;
  // height: 24px;
  // width: 184px;
  font-family: "Futura Std ", "Futura Std", sans-serif !important;
  line-height: 20px;
}

.carousel__video--theme {
  width: 184px;
  height: 28px;
  background-color: rgba(255, 255, 255, 0);
  box-sizing: border-box;
  font-family: "Futura Std ", "Futura Std", sans-serif;
  font-weight: 300;
  color: rgba(39, 36, 33, 0.7);
  text-align: left;
  line-height: 14px;
  letter-spacing: 1.5px;
}
.thumbnail-image {
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}
.subtitle2 {
  color: rgba(39, 36, 33, 0.7) !important;
}
.bg-transparent {
  background: transparent;
}
.carousel__video--wrapper {
  @media screen and (max-width: $media-sm) {
    width: unset !important ;
    display: flex;
  }
}
.carousel__video--detail,
.carousel__video--detail div {
  @media screen and (max-width: $media-sm) {
    width: unset !important ;
    // max-width: 144px;
  }
}
.play-btn {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 11;
  background: rgba(0, 0, 0, 0.5);
  height: 66px;
  width: 66px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    transform: rotate(90deg);
    padding-bottom: 5px;
    width: 26px;
    height: 26px;
  }
}
.bog-subtitle {
  font-family: $font-family-futura-std;
}

.blog-video-display{
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%) rotate(90deg);
}
</style>
